export * from "./listsActions";
export * from "./cardsActions";
export * from "./boardActions";

export const CONSTANTS = {
    ADD_CARD: "ADD_CARD",
    ADD_LIST: "ADD_LIST",
    DRAG_HAPPENED: "DRAG_HAPPENED",
    EDIT_CARD: "EDIT_CARD",
    DELETE_CARD: "DELETE_CARD",
    EDIT_LIST_TITLE: "EDIT_LIST_TITLE",
    DELETE_LIST: "DELETE_LIST",
    SET_ACTIVE_BOARD: "SET_ACTIVE_BOARD",
    ADD_BOARD: "ADD_BOARD"
};
